interface IParseTimeArgs {
    skipFloatConversion?: boolean;
    expectSeparator?: boolean; // when user fills mainly hours, expect ':' separator in the input, otherwise treat all inputs as hours
}

export const parseTimeUserInput = (value: string, args?: IParseTimeArgs): string => {
    const hasSeparator = value.includes(":");
    const trimmedValue = value.replace(":", "").replace(",",".").trim();

    const numeric = Number(trimmedValue);
    const isInt = Number.isInteger(numeric);

    if (isNaN(numeric) || !trimmedValue || ((args?.skipFloatConversion || hasSeparator) && !isInt)) {
        return null;
    }

    if (hasSeparator) {
        const [h, m] = value.split(":").map(v => v.trim());
        // when user types '1:2' we want to convert it to 01:02
        return `${h.padStart(2, "0")}${m.padStart(2, "0")}`;
    }

    if (!args?.skipFloatConversion && !isInt) {
        // first parse locale numbers and convert float numbers to hour+minute string
        // convert 1,5 -> 01:30
        const h = Math.floor(numeric);
        const m = Math.round((numeric - h) * 60);
        return `${h}${m.toString().padStart(2, "0")}`.padStart(4, "0");
    }
    if (args?.expectSeparator) {
        // when expecting separator but none found, treat all input as hours
        return `${trimmedValue.padStart(2, "0")}00`;
    }
    // when user types '1' (to 23) we want to convert it to hours not minutes (1:00 NOT 0:01)
    if (numeric >= 1 && numeric < 24) {
        return trimmedValue.padStart(2, "0").padEnd(4, "0");
    }
    if (numeric % 100 >= 60) {
        // invalid minutes, treat whole input as hours
        return `${trimmedValue}00`;
    }
    return trimmedValue.padStart(4, "0");
};
